// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-preview{height:calc(100vh - 134px)}.h-previewtree{height:calc(100vh - 215px)}.h-previewtree .el-tree>.el-tree-node:first-child .el-tree-node__content{padding-left:22px!important}.h-previewtree .el-tree>.el-tree-node:first-child .el-tree-node__content .el-tree-node__expand-icon{display:none}", ""]);
// Exports
module.exports = exports;
